<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">Diversion Books</span><br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1004<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Copyright © 2002 by </span><span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Sally Mandel</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</span></p>
<p class="double" style="text-align: center;">
	This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a>.</span></p>
<p style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">First Diversion Books edition September 2013</span><br/>
	ISBN: <span style="font-family: 'Liberation Serif', serif; font-size: 1em; line-height: 1.375; text-align: justify;">978-1-62681-123-2</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h3>
	More by Sally Mandel</h3>
<p class="first" style="text-align: center;">
<span href="#/chap161851" title="Link target outside of Sample">Take Me Back<br/>
	Change of Heart<br/>
	Quinn<br/>
	Out of the Blue<br/>
	Portrait of a Married Woman</span></p>
<p class="first" style="text-align: center;">
<span href="#/chap161851" title="Link target outside of Sample">A Time to Sing</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h5 style="text-align: center;">
	In memory of<br/>
	ELIZABETH TROUT<br/>
	with love and gratitude</h5>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap161643.vue?09e5c79d